import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { FiSidebar, FiUser } from 'react-icons/fi'
import { NavLink } from 'react-router-dom'
import MobileViewSidebar from './MobileViewSidebar'

function NavBar() {
  const [sidebarState, setSideBarState] = useState(false)
  const [profileState, setProfileState] = useState(false)

  const handelProfilePopup = () => {
    setProfileState(!profileState)
  }

  const handelMobileSidebar = () => {
    setSideBarState(!sidebarState)
  }

  return (
    <>
      <nav className=" flex w-full items-center justify-center px-4 py-2 shadow-md sm:max-h-7 sm:py-10  sm:shadow-none ">
        <div className="flex min-w-full  items-center justify-center">
          <div className="flex min-w-full items-center justify-between sm:justify-end ">
            <button
              className="flex h-9 items-center justify-center rounded-md border border-gray-100 p-2 shadow-sm sm:hidden "
              onClick={handelMobileSidebar}
            >
              <FiSidebar size={20} />
            </button>

            <button
              className="flex  items-center justify-center rounded-full border border-gray-200 p-2 shadow-sm"
              onClick={handelProfilePopup}
            >
              <FiUser className=" sm:size-5 md:size-7" />
              {profileState && <ProfileDropDown />}
            </button>
          </div>
        </div>
      </nav>
      {/* <AnimatePresence>
        {isSidebarOpen && (
          <MobileSidebar isOpen={isSidebarOpen} onClose={handleSidebarClose} />
        )}
      </AnimatePresence> */}

      <AnimatePresence>
        {sidebarState && (
          <MobileViewSidebar setSidebarState={setSideBarState} />
        )}
      </AnimatePresence>
    </>
  )
}

const ProfileDropDown = () => {
  return (
    <div className="absolute right-5 top-[70px] z-50 flex w-[130px] flex-col items-start justify-between rounded-md bg-white font-semibold  text-gray-600  shadow-md shadow-gray-400 transition-all duration-700">
      <NavLink
        to={'profile'}
        className={'flex items-center justify-center px-2 py-3'}
      >
        Your Profile
      </NavLink>
      <div className="h-px min-w-full bg-slate-400 "></div>
      <button className="flex items-center justify-center px-2 py-3">
        Sign Out
      </button>
    </div>
  )
}

export default NavBar
